export default __webpack_public_path__ + "static/media/mint.a5344d5d.png";